import { FeatureDTO } from "./FeatureDTO";

export class DisableFeaturedFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
